import type { JSX } from 'react';
import { ShieldCheck } from 'lucide-react';

const SITE_URL = 'https://careerverification.com';

/**
 * Issuer bar at the top of the certificate document.
 */
export function CertificateHeader(): JSX.Element {
  return (
    <header className="border-b border-border/60 bg-card">
      <div className="mx-auto flex max-w-4xl flex-wrap items-center justify-between gap-3 px-4 py-4 sm:px-8">
        <span className="flex items-center gap-2">
          <ShieldCheck aria-hidden="true" className="h-5 w-5 text-primary" />
          <span className="text-sm font-semibold tracking-tight">Career Verification</span>
        </span>
        <a
          href={SITE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm text-muted-foreground underline-offset-4 transition-colors hover:text-foreground hover:underline"
        >
          careerverification.com
        </a>
      </div>
    </header>
  );
}
